import Order from "@/pages/Purchase/Orders/Orders";
import OrderCreate from "@/pages/Purchase/Orders/Create/CreateOrder";
import OrderSale from "@/pages/Purchase/OrdersSale/OrdersSale";
import OrderSaleCreate from "@/pages/Purchase/OrdersSale/Create/CreateOrderSale";
import OrderDelivery from "@/pages/Purchase/OrdersDelivery/OrdersDelivery";
import OrderDeliveryCreate from "@/pages/Purchase/OrdersDelivery/Create/CreateOrderDelivery";
import OrderReturn from "@/pages/Purchase/OrdersReturn/OrdersReturn";
import OrderReturnCreate from "@/pages/Purchase/OrdersReturn/Create/CreateReturn";

const userRole = () => ["administrador", "gerente_agricola", "administrador_campo", "usuario"];

export const purchaseRoutes = [
	{
		path: `/ordenes_compra`,
		Component: Order,
		roles: userRole(),
	},
	{
		path: `/ordenes_compra/:option?/:code?`,
		Component: OrderCreate,
		roles: userRole(),
	},
	{
		path: `/facturas`,
		Component: OrderSale,
		roles: userRole(),
	},
	{
		path: `/facturas/:option?/:code?`,
		Component: OrderSaleCreate,
		roles: userRole(),
	},
	{
		path: `/guias_despacho`,
		Component: OrderDelivery,
		roles: userRole(),
	},
	{
		path: `/guias_despacho/:option?/:code?`,
		Component: OrderDeliveryCreate,
		roles: userRole(),
	},
	{
		path: `/sin_documento`,
		Component: OrderDelivery,
		roles: userRole(),
	},
	{
		path: `/sin_documento/:option?/:code?`,
		Component: OrderDeliveryCreate,
		roles: userRole(),
	},
	{
		path: `/nota_credito`,
		Component: OrderReturn,
		roles: userRole(),
	},
	{
		path: `/nota_credito/:option?/:code?`,
		Component: OrderReturnCreate,
		roles: userRole(),
	},
];
